module.exports = __webpack_public_path__ + "app/img/cartouche_moto_electro.cbf1bd1a.jpg";